<template>
  <div class="boxInfo">
    <el-tabs
      type="border-card" style="height: 100%;" :value="'first'"
      @tab-click="handleTabClick"
    >
      <!--'新增分区'\'分区详情'-->
      <el-tab-pane :label="typeIndex === 1 ? $t('basicData.AddPartition') : $t('basicData.PartitionDetails')" name="first">
        <div class="addFormBox">
          <el-form
            ref="queryForm"
            class="queryFormClass"
            :model="formData"
            :rules="rules"
            :label-width="$i18n.locale==='zh'?'120px':''"
            :label-position="$i18n.locale!=='zh'?'top':'right'"
            size="small"
          >
            <el-row>
              <el-col :span="20">
                <!--分区方案名称-->
                <el-form-item :label="$t('basicData.PartitionSchemeName')" prop="name">
                  <el-input
                    v-model.trim="formData.name"
                    :placeholder="$t('orderDetails.pleaseInput')"
                    clearable
                    maxlength="20"
                    show-word-limit
                  />
                </el-form-item>
              </el-col>
              <el-col :span="20">
                <!--业务类型-->
                <el-form-item :label="$t('collectionCenter.businessT')" prop="businessType">
                  <el-select v-model="formData.businessType" :placeholder="$t('GlobalSetObj.pleaseChoose')">
                    <el-option
                      v-for="item in BUSINESS_TYPE"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="20">
                <!--发件维度：空(null)=不参与 / 2=城市 / 3=区域 / 4=州（任意收件维度下都可参与或留空不参与）-->
                <el-form-item :label="$t('basicData.SenderDimension')">
                  <el-select
                    v-model="formData.sendDimension"
                    clearable
                    :placeholder="$t('basicData.SenderNotParticipate')"
                    @change="receiveDimensionChange"
                  >
                    <el-option key="1" :label="$t('collectionCenter.state')" :value="4" />
                    <el-option key="2" :label="$t('placeOrder.area')" :value="3" />
                    <el-option key="3" :label="$t('collectionCenter.city')" :value="2" />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="20">
                <!--收件维度：州/区域/城市/邮编-->
                <el-form-item :label="$t('basicData.RecipientDimension')">
                  <el-select
                    v-model="formData.receiveDimension"
                    :placeholder="$t('GlobalSetObj.pleaseChoose')"
                    @change="receiveDimensionChange"
                  >
                    <el-option key="1" :label="$t('collectionCenter.state')" :value="4" />
                    <el-option key="2" :label="$t('placeOrder.area')" :value="3" />
                    <el-option key="3" :label="$t('collectionCenter.city')" :value="2" />
                    <el-option key="4" :label="$t('basicData.zipCode')" :value="1" />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="20">
                <!--备注内容-->
                <el-form-item :label="$t('basicData.RemarkContent')">
                  <el-input
                    v-model="formData.remark"
                    :placeholder="$t('orderDetails.pleaseInput')"
                    type="textarea"
                    :rows="3"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>

          <!-- 分区明细列表：列按 发件维度/收件维度 动态切换控件与取值 -->
          <div>
            <div class="mb10 feet-r">
              <template v-if="typeIndex !== 3">
                <!--新增分区 -->
                <el-button
                  v-permit:remove="'but:finance:basicData:partition:edit'"
                  size="small"
                  type="primary"
                  @click="handleAdd"
                >{{ $t('basicData.AddPartition') }}
                </el-button>
                <!-- 导入/下载：发件维度(不选/州/区域/城市)与收件维度(邮编/州/区域/城市)所有组合均可；
                     模板列、下拉选项随所选发件/收件维度动态切换 -->
                <el-popover
                  :key="importComponentKey"
                  placement="bottom-start"
                  trigger="hover"
                >
                  <import-partition
                    :table-data="formData"
                    :sender-dimension="senderDimensionValue"
                    :receiver-dimension="receiveDimension"
                    :state-list="allState"
                    :all-city="allCity"
                    :area-list="areaList"
                    @importPartition="importPartitionData"
                  />
                  <!--导入/下载-->
                  <template #reference>
                    <el-button size="small" plain>
                      {{ $t('basicData.ImportDownload') }}
                    </el-button>
                  </template>
                </el-popover>
              </template>
              <!-- 收件维度=邮编：按邮编输入查询 -->
              <el-input
                v-if="receiveDimension === 1"
                v-model="searchText"
                :placeholder="$t('basicData.zipCode')"
                size="small"
                clearable
                style="width: 350px"
                @clear="clearHighlight"
              >
                <template #prepend>{{ receiverColHeader }}</template>
                <template #append>
                  <el-button icon="el-icon-search" @click="handleSearch" />
                </template>
              </el-input>
              <!-- 收件维度=州/区域/城市：单选下拉查询（州/区域支持模糊匹配，城市直接单选） -->
              <div v-else class="select-search">
                <span class="search-label">{{ receiverColHeader }}</span>
                <ElSelectV2
                  v-model="searchText"
                  :options="queryReceiverOptions"
                  :filterable="receiverQueryFilterable"
                  clearable
                  size="small"
                  style="width: 260px"
                  :placeholder="$t('GlobalSetObj.pleaseChoose')"
                />
                <el-button size="small" icon="el-icon-search" @click="handleSearch" />
              </div>
              <el-button-group>
                <el-button
                  :disabled="!hasSearchResults || currentHighlightIndex <= 0"
                  size="small" icon="el-icon-arrow-left"
                  @click="highlightPrev"
                >{{ $t('mdfeTranslate.Previous') }}</el-button>
                <el-button
                  :disabled="!hasSearchResults" size="small"
                  type="primary"
                >
                  {{ currentHighlightIndex + 1 }}/{{ searchResults.length }}
                </el-button>
                <el-button
                  :disabled="!hasSearchResults || currentHighlightIndex >= searchResults.length - 1"
                  size="small" @click="highlightNext"
                >{{ $t('mdfeTranslate.Next') }}
                  <i class="el-icon-arrow-right el-icon--right" /></el-button>
              </el-button-group>
            </div>
            <div>
              <virtual-scroll
                ref="virtualScroll"
                :key="key"
                :data="formData.partitionAffiliateList"
                :item-size="76"
                key-prop="key"
                @change="onVirtualChange"
              >
                <el-table
                  ref="tableRef"
                  :data="list"
                  row-key="key"
                  border
                  height="500"
                  :row-class-name="getRowClassName"
                  :highlight-current-row="false"
                >
                  <virtual-column width="80" type="index" />
                  <el-table-column :label="$t('basicData.PartitionName')" width="160">
                    <template #header>
                      <div>
                        <!--分区名称-->
                        <span style="color: red;">*</span>
                        <span>{{ $t('basicData.PartitionName') }}</span>
                      </div>
                    </template>
                    <template #default="scope">
                      <el-input
                        v-model="scope.row.partitionIdentifier"
                        maxlength="50"
                        show-word-limit
                        :placeholder="$t('basicData.PartitionName')"
                      />
                    </template>
                  </el-table-column>

                  <!-- 发件维度列（列名随 发件维度=不勾选/州/区域/城市 切换；未选发件维度时列置灰不可编辑） -->
                  <el-table-column :label="senderColHeader" width="230">
                    <template #header>
                      <div>
                        <span v-if="senderSelected" style="color: red;">*</span>
                        <span>{{ senderColHeader }}</span>
                        <!--<span>{{ $t('basicData.SenderStateColumn') }}/{{ $t('basicData.SenderAreaColumn') }}/{{ $t('basicData.SenderCityColumn') }}</span>-->
                      </div>
                    </template>
                    <template #default="scope">
                      <template v-if="senderDimensionValue === 4">
                        <el-select
                          v-model="scope.row.state"
                          clearable
                          filterable
                          style="width: 100%"
                          :placeholder="$t('GlobalSetObj.pleaseChoose')"
                        >
                          <el-option
                            v-for="item in stateOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          />
                        </el-select>
                      </template>
                      <template v-else-if="senderDimensionValue === 3">
                        <ElSelectV2
                          v-model="scope.row.state"
                          clearable
                          filterable
                          style="width: 100%"
                          :options="areaOptions"
                          :placeholder="$t('GlobalSetObj.pleaseChoose')"
                        />
                      </template>
                      <template v-else-if="senderDimensionValue === 2">
                        <ElSelectV2
                          v-model="scope.row.state"
                          clearable
                          filterable
                          style="width: 100%"
                          :options="cityOptions"
                          :placeholder="$t('GlobalSetObj.pleaseChoose')"
                        />
                      </template>
                      <template v-else>
                        <el-select
                          v-model="scope.row.state"
                          disabled
                          style="width: 100%"
                          :placeholder="$t('GlobalSetObj.pleaseChoose')"
                        />
                      </template>
                    </template>
                  </el-table-column>

                  <!-- 收件维度列：列名与控件随收件维度切换 -->
                  <el-table-column min-width="320">
                    <template #header>
                      <div>
                        <span style="color: red;">*</span>
                        <span>{{ receiverColHeader }}</span>
                        <!--<span v-else>{{ $t('basicData.ReceiverStateColumn') }}/{{ $t('basicData.ReceiverAreaColumn') }}/{{ $t('basicData.ReceiverCityColumn') }}</span>-->
                      </div>
                    </template>
                    <template #default="scope">
                      <!-- 收件维度=邮编 -->
                      <el-input
                        v-if="receiveDimension === 1"
                        v-model.trim="scope.row.postalCode"
                        type="textarea"
                        :rows="2"
                        :placeholder="$t('basicData.ZipCodeExample')"
                      />
                      <!-- 收件维度=州（可多选） -->
                      <el-select
                        v-else-if="receiveDimension === 4"
                        v-model="scope.row.city"
                        multiple
                        clearable
                        filterable
                        collapse-tags
                        :placeholder="$t('GlobalSetObj.pleaseChoose')"
                        style="width: 100%"
                      >
                        <el-option
                          v-for="item in stateOptions"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        />
                      </el-select>
                      <!-- 收件维度=区域（可多选） -->
                      <ElSelectV2
                        v-else-if="receiveDimension === 3"
                        v-model="scope.row.city"
                        multiple
                        clearable
                        filterable
                        collapse-tags
                        :options="areaOptions"
                        :placeholder="$t('GlobalSetObj.pleaseChoose')"
                        style="width: 100%"
                      />
                      <!-- 收件维度=城市（可多选；旧单值数据以单元素数组回显） -->
                      <ElSelectV2
                        v-else
                        v-model="scope.row.city"
                        multiple
                        clearable
                        filterable
                        collapse-tags
                        :options="cityOptions"
                        style="width: 100%"
                        :placeholder="$t('GlobalSetObj.pleaseChoose')"
                      />
                    </template>
                  </el-table-column>
                  <!--操作-->
                  <el-table-column :label="$t('basicData.operate')" width="120">
                    <template #default="scope">
                      <!--确定删除吗？-->
                      <el-popconfirm
                        :title="$t('basicData.AreYouSureYouWantToDelete')"
                        @confirm="handleDel(scope)"
                      >
                        <template #reference>
                          <!--删除-->
                          <el-button type="danger" size="mini">{{ $t('basicData.Delete') }}</el-button>
                        </template>
                      </el-popconfirm>
                    </template>
                  </el-table-column>
                </el-table>
              </virtual-scroll>
            </div>
          </div>
        </div>
        <div class="addFooter">
          <!--取消-->
          <el-button size="small" @click="() => handleUpdatePage(false)">{{ $t('basicData.Cancel') }}</el-button>
          <!--保存-->
          <el-button
            v-permit:remove="'but:finance:basicData:partition:edit'" size="small" type="primary"
            @click="submitForm"
          >{{ $t('basicData.Save') }}</el-button>
        </div>
      </el-tab-pane>
      <!--操作日志-->
      <el-tab-pane v-if="typeIndex === 2" :label="$t('basicData.OperationalLogs')" name="second">
        <operation-log
          v-if="isSecondActive" :edit-data="editData" :all-city="allCity"
          :all-state="allState"
        />
      </el-tab-pane>
    </el-tabs>
    <!--保存提示-->
    <el-dialog
      :title="$t('basicData.tips')"
      :visible.sync="dialogVisible"
      :append-to-body="true"
      width="45%"
    >
      <div v-for="(item, ind) in errData" :key="ind" style="color: red;margin-bottom: 10px;">{{ item }}</div>
      <span slot="footer" class="dialog-footer">
        <!--确 定-->
        <el-button type="primary" @click="dialogVisible = false">{{ $t('basicData.determine') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { apiAffiliateAdd, apiAffiliateDelete, apiAffiliateEdit, apiGetAffiliateById } from '@/api/finance/partition';
import { apiRegionalLevelOptions } from '@/api/finance/basicData';
import { compressList } from '@/utils/zipcode';
import { Loading } from 'element-ui';
import { cloneDeep } from 'lodash-es';
import { rowComparison, postalCodeFormat, checkZipCode } from './utils';
import { BUSINESS_TYPE } from '@/views/finance/enums.js';
import VirtualScroll, { VirtualColumn } from 'el-table-virtual-scroll';
import ElSelectV2 from 'el-select-v2';

const options = {
  lock: true,
  spinner: 'el-icon-loading',
  text: 'loading...',
  background: 'rgba(250, 250, 250, 0.6)' // 加载动画的背景
};

// 发件维度枚举：null/0 表示发件方不参与分区匹配；2 城市  3 区域  4 州
const SENDER_DIM_CITY = 2;
const SENDER_DIM_AREA = 3;
const SENDER_DIM_STATE = 4;
// 收件维度枚举：1 邮编  2 城市  3 区域  4 州
const RECEIVE_DIM_ZIP = 1;
const RECEIVE_DIM_CITY = 2;
const RECEIVE_DIM_AREA = 3;
const RECEIVE_DIM_STATE = 4;

// 添加模板：state 存发件维度值；city 存收件非邮编值（州/区域/城市，兼容旧多城市数组）；postalCode 存收件邮编
const addTmp = {
  partitionIdentifier: '',
  state: '',
  postalCode: '',
  city: [],
  id: undefined
};

export default {
  components: {
    VirtualColumn,
    ElSelectV2,
    'import-partition': () => import('./ImportPartition'),
    'operation-log': () => import('./operationLog'),
    VirtualScroll
  },
  props: {
    // 类型标识 1新增 3查看 2编辑
    typeIndex: {
      type: Number,
      default: 1
    },
    editData: {
      type: Object,
      default: () => {
        return {};
      }
    },

    // 所有一级州
    allState: {
      type: Array,
      default: () => {
        return [];
      }
    },
    allCity: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      BUSINESS_TYPE,
      list: [],
      virtualStart: 0,
      key: new Date().getTime(),
      isSecondActive: false,
      rules: {
        name: [
          { required: true, message: this.$t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] },
          // '长度在 2 到 20 个字符'
          {
            min: 2,
            max: 20,
            message: this.$t('basicData.TheLengthBetween2And20Characters'),
            trigger: ['blur', 'change']
          }
        ],
        businessType: { required: true, message: this.$t('basicData.CannotBeEmpty'), trigger: ['blur', 'change'] }
      },
      errData: [],
      dialogVisible: false,
      formData: {
        name: '',
        remark: '',
        businessType: '',
        sendDimension: null,
        receiveDimension: RECEIVE_DIM_ZIP,
        partitionAffiliateList: []
      },
      // 区域选项（/area/regionalLevelOptions 返回，dictValue 字符串为区域取值）
      areaList: [],
      // 响应式数据
      visibleData: [],
      searchText: '',
      searchResults: [],
      currentHighlightIndex: -1
    };
  },

  computed: {
    hasSearchResults() {
      return this.searchResults.length > 0;
    },
    // 发件维度（归一化）
    senderDimensionValue() {
      return Number(this.formData.sendDimension) || null;
    },
    // 发件维度是否已选择（非空即参与：等价于旧版“有始发州”开关打开）
    senderSelected() {
      return [SENDER_DIM_STATE, SENDER_DIM_AREA, SENDER_DIM_CITY].includes(this.senderDimensionValue);
    },
    // 收件维度（归一化）
    receiveDimension() {
      return Number(this.formData.receiveDimension) || RECEIVE_DIM_ZIP;
    },
    // 收件维度列名（州/区域/城市/邮编，随收件维度切换）
    receiverColHeader() {
      const map = {
        [RECEIVE_DIM_ZIP]: 'basicData.ReceiverZipColumn',
        [RECEIVE_DIM_CITY]: 'basicData.ReceiverCityColumn',
        [RECEIVE_DIM_STATE]: 'basicData.ReceiverStateColumn',
        [RECEIVE_DIM_AREA]: 'basicData.ReceiverAreaColumn'
      };
      return this.$t(map[this.receiveDimension] || map[RECEIVE_DIM_ZIP]);
    },
    // 发件维度列名（发件州/发件区域/发件城市；未选发件维度时按“发件州”展示并置灰）
    senderColHeader() {
      const map = {
        [SENDER_DIM_AREA]: 'basicData.SenderAreaColumn',
        [SENDER_DIM_CITY]: 'basicData.SenderCityColumn'
      };
      return this.$t(map[this.senderDimensionValue] || 'basicData.SenderStateColumn');
    },
    // 收件维度查询下拉是否支持模糊匹配（州/区域支持，城市直接单选）
    receiverQueryFilterable() {
      return this.receiveDimension === RECEIVE_DIM_STATE || this.receiveDimension === RECEIVE_DIM_AREA;
    },
    // 收件维度查询下拉选项（值=展示文本，与行内收件显示文本一致，用于命中定位）
    queryReceiverOptions() {
      return this.receiverOptions.map(item => ({
        value: item.label,
        label: item.label
      }));
    },
    // 导入控件 key：发件/收件维度切换时重建，避免残留上一维度模板内容
    importComponentKey() {
      return `${this.senderDimensionValue || 0}-${this.receiveDimension}`;
    },
    // 州下拉选项（值=地区id，统一数字类型，保证与行内值匹配回显）
    stateOptions() {
      return this.allState.map(item => ({
        value: Number(item.value),
        label: item.label,
        name: item.name
      }));
    },
    // 城市下拉选项（州-城市组合，值=地区id，统一数字类型，保证与行内值匹配回显）
    cityOptions() {
      return this.allCity.map(item => {
        const twoCode = item.parentNode && item.parentNode.twoCode ? item.parentNode.twoCode : '';
        return {
          value: Number(item.value),
          label: `${twoCode}-${item.name || ''}`,
          name: item.name || ''
        };
      });
    },
    // 区域下拉选项（/area/regionalLevelOptions 返回；label=dictName、value=dictValue（字符串））
    areaOptions() {
      return this.areaList.map(item => ({
        value: item.dictValue,
        label: item.dictName
      }));
    },
    // 收件维度查询/下拉所用选项
    receiverOptions() {
      if (this.receiveDimension === RECEIVE_DIM_STATE) {
        return this.stateOptions;
      }
      if (this.receiveDimension === RECEIVE_DIM_AREA) {
        return this.areaOptions;
      }
      if (this.receiveDimension === RECEIVE_DIM_CITY) {
        return this.cityOptions;
      }
      return [];
    },
    receiverOptionsMap() {
      const map = {};
      this.receiverOptions.forEach(item => {
        map[item.value] = item.label;
      });
      return map;
    }
  },

  watch: {
    searchText(newVal) {
      if (!newVal) {
        this.clearHighlight();
      } else {
        this.handleSearch(); // 自动搜索定位
      }
    }
  },
  created() {
    // 加载区域层级选项（区域维度下拉/回显依赖）
    this.loadAreaOptions();
    if (this.editData.id) {
      // 报价页面查看分区使用partitionId， 分区页面使用id
      const ids = this.typeIndex === 3 ? this.editData.partitionId : this.editData.id;
      this.asyncGetAffiliateById(ids);
    }
  },
  methods: {
    // 虚拟滚动 change 事件：renderData 是切片，记录起始索引 start 用于修正 el-form-item 的 prop 真实索引
    onVirtualChange(virtualList, start) {
      this.list = virtualList;
      this.virtualStart = start || 0;
    },
    // 发件维度/收件维度切换后，明细行语义变化，需重新录入
    receiveDimensionChange() {
      this.formData.partitionAffiliateList = [];
      this.key = new Date().getTime();
      this.searchText = '';
      this.searchResults = [];
      this.currentHighlightIndex = -1;
    },
    // 加载区域层级选项（区域维度下拉/回显依赖；label=dictName、value=dictValue）
    loadAreaOptions() {
      apiRegionalLevelOptions({}).then(res => {
        const { code, data } = res;
        if (code === 200 && data && Array.isArray(data.records)) {
          this.areaList = data.records;
        }
      }).catch(() => {
        // 区域选项加载失败不阻塞分区编辑，仅区域维度下拉为空
      });
    },
    handleTabClick(tab) {
      if (tab.name === 'second' && !this.isSecondActive) {
        this.isSecondActive = true; // 触发 ConfigManagement 组件的加载和初始化请求
      }
    },
    // 增加分区
    handleAdd() {
      this.formData.partitionAffiliateList = this.formData.partitionAffiliateList || [];
      const obj = {
        ...addTmp,
        key: `item-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`
      };
      this.formData.partitionAffiliateList.push(obj);
    },
    // 导入分区数据（发件维度(不选/州/区域/城市)×收件维度(邮编/州/区域/城市) 统一入口；
    // 模板下载/导入解析、必填/重复校验均在 ImportPartition 组件内按所选维度处理）
    importPartitionData(arr) {
      // 发件维度已参与时（等价旧“有始发州”开关打开），导入行必须填写发件值
      if (this.senderSelected) {
        const isBool = arr.every(item => {
          const val = item.state;
          return val !== null && val !== undefined && val !== '';
        });
        if (!isBool) {
          const str = this.$t('CenterForSorting.Import'); // 导入
          const str2 = this.$t('GlobalSetObj.pleaseChoose'); // 请选择
          this.$message.warning(`${str}${str2}${this.senderColHeader}`);
          return;
        }
      }
      const partitionAffiliateList = cloneDeep(this.formData.partitionAffiliateList);
      const dim = this.receiveDimension;

      arr.forEach(originalItem => {
        const processedItem = {
          partitionIdentifier: originalItem.name || '',
          id: originalItem.id || ''
        };
        if (dim === RECEIVE_DIM_ZIP) {
          // 收件维度=邮编：压缩邮编区间段后并入（与旧 zip 导入逻辑一致）
          processedItem.postalCode = compressList(
            String(originalItem.zipcode || '').trim().replace(/[\uff0c，]/g, ',')
          ).join(',');
        } else {
          // 收件维度=州/区域/城市：模板一个格子可填多个值（英文逗号分隔），统一以数组并入
          const cityVal = originalItem.city;
          processedItem.city = Array.isArray(cityVal)
            ? cityVal
            : (cityVal !== null && cityVal !== undefined && cityVal !== '' ? [cityVal] : []);
        }
        // 发件值类型化：发件维度=区域 取字符串 dictValue，城市/州 取数字地区 id；未选发件维度时置空
        processedItem.state = this.senderSelected
          ? this.normalizeSenderValue(this.senderDimensionValue, originalItem.state)
          : '';

        // Excel 中 ID 可能被读成字符串，比较时统一转字符串，保证“下载分区后修改再导入”可命中更新
        const existingIndex = processedItem.id
          ? partitionAffiliateList.findIndex(i => String(i.id) === String(processedItem.id))
          : -1;

        if (existingIndex !== -1) {
          partitionAffiliateList[existingIndex] = processedItem;
        } else if (!processedItem.id) {
          partitionAffiliateList.push(processedItem);
        }
      });
      const ArrList = partitionAffiliateList.map((item, index) => {
        return {
          ...item,
          id: item.id || '',
          key: this.generateUniqueKey(index)
        };
      });
      this.formData.partitionAffiliateList = ArrList;
      this.key = new Date().getTime();
    },
    generateUniqueKey(index) {
      return `item-${Date.now()}-${index}-${Math.random().toString(36).substr(2, 9)}`;
    },
    // 删除分区
    handleDel(scope) {
      if (scope.row.id) {
        apiAffiliateDelete(scope.row.id).then(res => {
          if (res.code === 200) {
            this.$message.success(this.$t('basicData.TheOperationSucceeded')); // 操作成功
          }
        });
      }
      this.formData.partitionAffiliateList.splice(scope.$index, 1);
    },
    // 取消
    handleUpdatePage(type) {
      this.$emit('updatePage', type);
    },

    // ---------- 明细行取值/回显辅助 ----------
    // 收件非邮编值归一化（兼容字符串、数组、单个 id）
    // 州/城市 值为地区数字 id；区域值为字符串 dictValue。按收件维度类型化后去重返回数组
    normalizeReceiverValue(val, dim) {
      const d = dim || this.receiveDimension;
      const source = Array.isArray(val)
        ? val
        : (val === null || val === undefined || val === '' ? [] : String(val).split(','));
      const result = [];
      const seen = new Set();
      source.forEach(v => {
        if (v === null || v === undefined || v === '') return;
        let item;
        if (d === RECEIVE_DIM_AREA) {
          item = String(v).trim();
          if (!item) return;
        } else {
          item = Number(v);
          if (Number.isNaN(item)) return;
        }
        if (!seen.has(item)) {
          seen.add(item);
          result.push(item);
        }
      });
      return result;
    },
    // 发件值类型化：区域为字符串 dictValue，州/城市为数字地区 id
    normalizeSenderValue(senderDim, val) {
      if (senderDim === SENDER_DIM_AREA) {
        return val === null || val === undefined ? '' : String(val).trim();
      }
      const num = Number(val);
      return Number.isNaN(num) ? '' : num;
    },
    // 行内收件值列表（州/区域/城市维度）
    receiverIds(row) {
      if (this.receiveDimension === RECEIVE_DIM_ZIP) {
        return [];
      }
      return this.normalizeReceiverValue(row.city, this.receiveDimension);
    },
    // 行内收件显示文本（用于模糊匹配查询）
    rowReceiverLabels(row) {
      const map = this.receiverOptionsMap;
      return this.receiverIds(row).map(v => map[v]).filter(Boolean);
    },
    // 提交时收件值字符串化：城市/州为逗号分隔地区 id；区域为逗号分隔 dictValue
    receiverValueToString(val) {
      const items = this.normalizeReceiverValue(val, this.receiveDimension);
      return items.join(',');
    },

    // ---------- 明细行校验 ----------
    // 返回错误信息数组；无错误返回空数组
    verifyRows() {
      const rows = this.formData.partitionAffiliateList || [];
      const errors = [];
      const senderSelected = this.senderSelected;
      const dim = this.receiveDimension;
      const rowTag = no => `${this.$t('basicData.row')}${no}${this.$t('basicData.line')}`;

      rows.forEach((row, index) => {
        const no = index + 1;
        // 分区名称必填
        if (!(row.partitionIdentifier || '').trim()) {
          errors.push(`${rowTag(no)}${this.$t('basicData.PartitionName')}${this.$t('basicData.CannotBeEmpty')}`);
        }
        // 发件维度已选时，每行发件值必填
        if (senderSelected && !row.state) {
          errors.push(`${rowTag(no)}${this.senderColHeader}${this.$t('GlobalSetObj.pleaseChoose')}`);
        }
        if (dim === RECEIVE_DIM_ZIP) {
          // 收件邮编：必填 + 格式 + 同区间内重叠
          const postal = (row.postalCode || '').trim();
          const [isFormatOk, formatText] = postalCodeFormat(postal);
          if (!isFormatOk) {
            errors.push(`${rowTag(no)}${formatText}`);
            return;
          }
          const [isRowOk, rowText] = rowComparison(postal);
          if (!isRowOk) {
            errors.push(`${rowTag(no)}${rowText}`);
          }
        } else {
          // 收件维度=州/区域/城市：每行必选
          if (this.receiverIds(row).length === 0) {
            errors.push(`${rowTag(no)}${this.receiverColHeader}${this.$t('GlobalSetObj.pleaseChoose')}`);
          }
        }
      });

      if (errors.length > 0) {
        return errors;
      }
      if (dim === RECEIVE_DIM_ZIP) {
        // 同一发件值分组下的邮编区间交集校验
        const groupList = rows.map(row => ({
          partitionIdentifier: row.partitionIdentifier,
          postalCode: (row.postalCode || '').trim(),
          state: senderSelected ? row.state : ''
        }));
        const zipErrors = checkZipCode(groupList);
        errors.push(...zipErrors);
      } else {
        // 州/区域/城市 值不允许跨行重复（勾选发件维度时，允许同收件值挂不同发件值）
        const seen = new Map();
        const reported = new Set();
        rows.forEach((row, index) => {
          const senderKey = senderSelected ? `s:${String(row.state || '')}` : 'g';
          this.receiverIds(row).forEach(v => {
            const key = `${senderKey}#${v}`;
            if (seen.has(key)) {
              if (!reported.has(key)) {
                reported.add(key);
                errors.push(
                  `${rowTag(seen.get(key))}与${rowTag(index + 1)}：${this.receiverColHeader}${this.$t('basicData.ValueCannotBeRepeated')}`
                );
              }
            } else {
              seen.set(key, index + 1);
            }
          });
        });
      }
      // 分区名称不允许重复（同一分区方案内需唯一）
      const nameMap = new Map();
      rows.forEach((row, index) => {
        const name = (row.partitionIdentifier || '').trim();
        if (!name) {
          return;
        }
        if (nameMap.has(name)) {
          errors.push(
            `${rowTag(nameMap.get(name))}与${rowTag(index + 1)}：${this.$t('basicData.PartitionName')}${this.$t('basicData.ValueCannotBeRepeated')}`
          );
        } else {
          nameMap.set(name, index + 1);
        }
      });
      return errors;
    },

    // 处理提交的数据格式
    setSubmitFormDataType() {
      const { name, remark, businessType, sendDimension, receiveDimension, partitionAffiliateList } = this.formData;
      const row = {
        id: undefined,
        name,
        businessType,
        remark,
        attribute: 1,
        sendDimension,
        receiveDimension,
        partitionAffiliateList: []
      };

      row.partitionAffiliateList = partitionAffiliateList.map(item => {
        const obj = {
          partitionIdentifier: item.partitionIdentifier || '',
          id: item.id || '',
          partitionId: this.editData.id
        };
        if (this.senderSelected) {
          // 发件维度已选：州/区域/城市值统一放在 state 字段，由后端按 sendDimension 解释
          obj.state = item.state;
        } else {
          obj.state = undefined;
        }
        if (receiveDimension === RECEIVE_DIM_ZIP) {
          obj.postalCode = (item.postalCode || '').trim();
        } else {
          // 收件维度为州/区域/城市时，值统一放在 city 字段，由后端按 receiveDimension 解释
          obj.city = this.receiverValueToString(item.city);
        }
        return obj;
      });

      return row;
    },

    // 新增
    asyncAffiliateAdd(obj) {
      apiAffiliateAdd(obj).then(res => {
        const { code } = res;
        if (code !== 200) {
          return;
        }
        this.$message.success(this.$t('basicData.TheOperationSucceeded')); // 操作成功
        this.handleUpdatePage(true);
      }).catch(err => {
        console.error(err);
      });
    },
    // 查看分区详情
    asyncGetAffiliateById(ids) {
      apiGetAffiliateById(ids).then(res => {
        const { code, data } = res;
        if (code !== 200) {
          return;
        }

        if (!data || typeof data !== 'object') {
          return;
        }

        const {
          businessType,
          name,
          remark,
          sendDimension,
          receiveDimension,
          partitionAffiliateList
        } = data;

        const dim = Number(receiveDimension) || RECEIVE_DIM_ZIP;
        // sendDimension: 0/null/undefined = 发件方不参与(等价旧 stateOfOrigin===0)；
        // 2=城市 / 3=区域 / 4=州 即发件参与(等价旧 stateOfOrigin===1)，与收件维度是否邮编无关
        const rawSenderDim = Number(sendDimension) || null;
        const senderDim = [SENDER_DIM_STATE, SENDER_DIM_AREA, SENDER_DIM_CITY].includes(rawSenderDim) ? rawSenderDim : null;

        const arr = (partitionAffiliateList || []).map(item => {
          const { partitionIdentifier, postalCode, id, state, city } = item;
          const ids = this.normalizeReceiverValue(city, dim);
          return {
            id,
            partitionIdentifier,
            postalCode,
            // 收件维度=州/区域/城市：一律以数组承载（多选列控件；旧单值数据也以单元素数组回显）
            city: ids,
            // 发件值类型化：发件维度=区域时取字符串 dictValue，其余为数字地区 id
            state: senderDim ? this.normalizeSenderValue(senderDim, state) : '',
            key: this.generateUniqueKey(id)
          };
        });

        this.formData = {
          businessType,
          name,
          remark,
          receiveDimension: dim,
          sendDimension: senderDim,
          partitionAffiliateList: arr
        };
      }).catch(err => {
        console.error('API request error:', err);
      });
    },

    // 编辑
    asyncAffiliateEdit(obj) {
      apiAffiliateEdit(obj).then(res => {
        const { code } = res;
        if (code !== 200) {
          return;
        }
        this.$message.success(this.$t('basicData.TheOperationSucceeded'));
        this.handleUpdatePage(true);
      }).catch(err => {
        console.error(err);
      });
    },
    /**
     * 提交表单
     */
    async submitForm() {
      try {
        // 头部表单校验
        let isFormValid = false;
        try {
          isFormValid = await this.$refs.queryForm.validate();
        } catch (e) {
          isFormValid = false;
        }
        if (!isFormValid) return;

        if (!this.formData.partitionAffiliateList || this.formData.partitionAffiliateList.length === 0) {
          this.$message.warning(this.$t('basicData.PleaseAddPartitions'));
          return;
        }
        // 明细行校验（含必填、邮编格式/交集、值重复）
        const errData = this.verifyRows();
        if (errData.length > 0) {
          this.errData = errData;
          this.dialogVisible = true;
          return;
        }
        let loading;
        try {
          loading = Loading.service(options);
          const submitData = this.setSubmitFormDataType();

          if (this.typeIndex === 1) {
            this.asyncAffiliateAdd(submitData);
          } else {
            // 编辑时，分区id需要传递过来报价页面取partitionId
            submitData.id = this.typeIndex === 3 ? this.editData.partitionId : this.editData.id;
            this.asyncAffiliateEdit(submitData);
          }
        } finally {
          if (loading) {
            loading.close();
          }
        }
      } catch (error) {
        console.error('Submission Error:', error);
      }
    },

    // ---------- 查询/高亮 ----------
    // 搜索处理
    handleSearch() {
      const keyword = (this.searchText || '').trim();
      const tableData = this.formData.partitionAffiliateList;

      if (!keyword) {
        this.searchResults = [];
        this.currentHighlightIndex = -1;
        return;
      }

      let results = [];
      if (this.receiveDimension === RECEIVE_DIM_ZIP) {
        // 邮编维度：输入号码后，匹配命中该号码的区间所在行
        const number = Number(keyword);
        if (!Number.isNaN(number)) {
          results = tableData
            .map((row, index) => ({ row, index }))
            .filter(item => {
              const { postalCode } = item.row;
              const postalCodeList = this.parseDataRanges(postalCode || '');
              const { matched } = this.matchZipNumber(number, postalCodeList);
              return matched;
            });
        }
      } else {
        // 州/区域/城市维度：对行内收件显示文本做包含匹配（支持模糊匹配）
        const lower = keyword.toLowerCase();
        results = tableData
          .map((row, index) => ({ row, index }))
          .filter(item => {
            const labels = this.rowReceiverLabels(item.row);
            return labels.some(label => String(label).toLowerCase().includes(lower));
          });
      }

      this.searchResults = results;
      this.currentHighlightIndex = results.length ? 0 : -1;

      if (results.length > 0) {
        this.$nextTick(() => this.scrollToHighlightedRow());
      }
    },

    // 下一个
    highlightNext() {
      if (!this.hasSearchResults) return;
      this.currentHighlightIndex = (this.currentHighlightIndex + 1) % this.searchResults.length;
      this.$nextTick(() => this.scrollToHighlightedRow());
    },

    // 上一个
    highlightPrev() {
      if (!this.hasSearchResults) return;
      this.currentHighlightIndex =
        this.currentHighlightIndex <= 0
          ? this.searchResults.length - 1
          : this.currentHighlightIndex - 1;
      this.$nextTick(() => this.scrollToHighlightedRow());
    },

    // 滚动到当前高亮行
    scrollToHighlightedRow() {
      // 获取表格的虚拟滚动实例
      const virtualScroll = this.$refs.virtualScroll.$el;

      if (this.currentHighlightIndex < 0) return;

      const currentMatch = this.searchResults[this.currentHighlightIndex];
      if (!currentMatch) return;

      const rowIndex = currentMatch.index;

      const rowHeight = 76; // 每行的预计高度，根据实际情况调整
      const viewportHeight = virtualScroll.clientHeight; // 可视区域高度
      const maxRowsInViewport = Math.floor(viewportHeight / rowHeight); // 可视区域最多能显示的行数
      const startIndex = Math.max(0, rowIndex - Math.floor(maxRowsInViewport / 2)); // 计算开始滚动的行索引
      const scrollTop = rowHeight * startIndex; // 计算需要滚动的位置
      this.setScrollTop(scrollTop);

      // 强制表格重新渲染以应用高亮样式
      this.$nextTick(() => {
        if (this.$refs.virtualScroll && this.$refs.virtualScroll.doLayout) {
          this.$refs.virtualScroll.doLayout();
        }
      });
    },
    // 清空搜索结果
    clearHighlight() {
      this.searchText = '';
      this.searchResults = [];
      this.currentHighlightIndex = -1;
      this.$nextTick(() => {
        this.setScrollTop();
      });
    },
    // 设置滚动距离
    setScrollTop(top = 0) {
      const tableRef = this.$refs.tableRef.$el.querySelector('.el-table__body-wrapper'); // 表格元素
      if (tableRef && tableRef.scrollTo) {
        tableRef.scrollTo({
          top: top,
          behavior: 'smooth'
        });
      }
    },

    // 获取行类名
    getRowClassName({ row }) {
      return this.isRowHighlighted(row) ? 'highlighted-row' : '';
    },

    // 检查行是否高亮
    isRowHighlighted(row) {
      if (this.currentHighlightIndex < 0) return false;

      const currentResult = this.searchResults[this.currentHighlightIndex];
      return currentResult && currentResult.row.key === row.key;
    },
    // 邮编匹配规则
    matchZipNumber(number, parsedRanges) {
      let matched = false;
      for (const range of parsedRanges) {
        if (range.type === 'single') {
          if (range.value.includes(number)) {
            matched = true;
            break;
          }
        } else if (range.type === 'range') {
          if (number >= range.start && number <= range.end) {
            matched = true;
            break;
          }
        }
      }
      return { matched };
    },
    // 邮编解析
    parseDataRanges(code) {
      const ranges = [];
      const parts = code.split(',');
      for (const part of parts) {
        const trimmedPart = part.trim();
        if (trimmedPart.includes('~')) {
          const [start, end] = trimmedPart.split('~').map(num => parseFloat(num.trim()));
          if (!isNaN(start) && !isNaN(end)) {
            ranges.push({ type: 'range', start, end });
          }
        } else {
          const num = parseFloat(trimmedPart);
          if (!isNaN(num)) {
            ranges.push({ type: 'single', value: num.toString() });
          }
        }
      }
      return ranges;
    }
  }
};
</script>

<style scoped lang="scss">
::v-deep .highlighted-row,
::v-deep .highlighted-row:hover > td {
  background-color: #e6f7ff !important;
}

::v-deep .highlighted-row {
  position: relative;
}

::v-deep .highlighted-row::after {
  position: absolute;
  content: '';
  width: 5px;
  height: 100%;
  background-color: #00A551;
  left: 0;
}

::v-deep .el-table__row {
  transition: all 0.3s ease;
}

.boxInfo {
  height: 100%;

  ::v-deep .el-tabs__content {
    padding: 0;

    .el-tab-pane {
      height: 100%;

      .addFormBox {
        height: calc(100vh - 96px);
        padding: 15px;
        overflow-y: auto;
      }
    }
  }

  .addFooter {
    border-top: 1px solid #ccc;
    padding: 10px;
    text-align: right;
  }

  .select-search {
    display: inline-block;
    padding-left: 10px;
    background: #f9fafb;
    border-radius: 3px;

    .search-label {
      margin-right: 10px;
    }
  }
}
</style>
